import React, { useState, useEffect } from "react";
import MyCount from "../../../components/MyPage/MyCount";
import BoardForm from "../../../components/MyPage/BoardForm";
import PaginationSection from "../../../components/Product/Pagination";
import { INQUIRY_LIST_URL, MAKING_SUPPORT_MY_PAGE_LIST_URL } from "../../../utils/urls";
import instance from "../../../services/services";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useLanguage } from "../../../hooks/useLanguage";

function InquiryList({inquiryType}){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { myInfo } = useOutletContext();
  const [isTablet, setIsTablet] = useState(false);
  const [inquiryData, setInquiryData] = useState([]); // 1:1 문의 데이터
  const [totalCount, setTotalCount] = useState(0); // 총 데이터 개수
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지
  const [itemsPerPage] = useState(12); // 페이지당 항목 수
  const [makingSupportData, setMakingSupportData] = useState([]); // 제작지원 데이터
  const [makingSupportTotalCount, setMakingSupportTotalCount] = useState(0); // 제작지원 총 데이터 개수
  const [customizingData, setCustomizingData] = useState([]); // 커스터마이징 데이터
  const [customizingTotalCount, setCustomizingTotalCount] = useState(0); // 커스터마이징 총 데이터 개수
  const [priceGuaranteeData, setPriceGuaranteeData] = useState([]); // 최저가 보장 데이터
  const [priceGuaranteeTotalCount, setPriceGuaranteeTotalCount] = useState(0); // 최저가 보장 총 데이터 개수

  // 모바일 체크
  useEffect(() => {
    const checkTablet = () => {
      setIsTablet(window.innerWidth < 768);
    };
    
    checkTablet();
    window.addEventListener('resize', checkTablet);
    
    return () => window.removeEventListener('resize', checkTablet);
  }, []);

  // 1:1 문의 리스트
  useEffect(() => {
    const fetchCategoryData = async () => {

      if (inquiryType !== 'inquiry' || !myInfo?.member_seq) return;

      try {
        const response = await instance.post(INQUIRY_LIST_URL, {
          boardid: "mbqna",
          member_chk: "Y",
          board_type: "",
          offset: currentPage, // 현재 페이지에 따라 오프셋 설정
          member_seq: myInfo?.member_seq,
          limit: itemsPerPage
        });
        setInquiryData(response.data.data.data);
        setTotalCount(response.data.data.cntRow);
      } catch (error) {
        console.error('실패', error);
      }
    }

    fetchCategoryData();
  }, [inquiryType, myInfo, currentPage, itemsPerPage]); 

  // 제작지원 리스트
  useEffect(() => {
    const fetchMakingSupportData = async () => {
      if (inquiryType !== 'support') return;

      try {
        const response = await instance.post(MAKING_SUPPORT_MY_PAGE_LIST_URL, {
          offset: currentPage,
          limit: itemsPerPage
        });
        setMakingSupportData(response.data.data.data);
        setMakingSupportTotalCount(response.data.data.total_count);
      } catch (error) {
        console.error('실패', error);
      }
    }

    fetchMakingSupportData();
  }, [inquiryType, currentPage, itemsPerPage])  


    // 커스터마이징 리스트
    useEffect(() => {
      const fetchCategoryData = async () => {
  
        if (inquiryType !== 'customizing' || !myInfo?.member_seq) return;
  
        try {
          const response = await instance.post(INQUIRY_LIST_URL, {
            boardid: "custom",
            member_chk: "Y",
            offset: currentPage, // 현재 페이지에 따라 오프셋 설정
            limit: itemsPerPage,
            member_seq: myInfo?.member_seq,
          });
          setCustomizingData(response.data.data.data);
          setCustomizingTotalCount(response.data.data.cntRow);
        } catch (error) {
          console.error('실패', error);
        }
      }
  
      fetchCategoryData();
    }, [inquiryType, myInfo, currentPage, itemsPerPage]);

    // 최저가 보장 리스트
    useEffect(() => {
      const fetchCategoryData = async () => {
  
        if (inquiryType !== 'priceGuarantee' || !myInfo?.member_seq) return;
  
        try {
          const response = await instance.post(INQUIRY_LIST_URL, {
            boardid: "lowest",
            member_chk: "Y",
            offset: currentPage, 
            limit: itemsPerPage,
            member_seq: myInfo?.member_seq,
          });
          setPriceGuaranteeData(response.data.data.data);
          setPriceGuaranteeTotalCount(response.data.data.cntRow);
        } catch (error) {
          console.error('실패', error);
        }
      }
  
      fetchCategoryData();
    }, [inquiryType, myInfo, currentPage, itemsPerPage]); 

        
  // 1:1문의 문의하기
  const handleInquiry = () => {
    navigate('/community/inquiry/write', { state: { inquiryType: 'mypage' } });
  } 

  // 커스터마이징 글쓰기
  const handleCustomizing = () => {
    navigate('/community/customizing/write', { 
      state: { from: 'mypage' } // 마이페이지에서 온 것을 표시
    });
  }

  // 최저가 보장 제보하기
  const handlePriceGuarantee = () => {
    navigate('/community/priceGuarantee/write', { state: { from: 'mypage' } });
  }

  // 페이지 변경 핸들러
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    // window.scrollTo(0, 0); // 페이지 변경 시 스크롤을 맨 위로 이동
  };

// 제작지원, 1:1문의, 커스터마이징, 최저가 보장
  return(
    <div>
      <div>
        {/* 장바구니 / 관심상품 / 쿠폰 */}
        {!isTablet && <MyCount/>}

        {inquiryType === 'support' ? (
          // 제작지원
          <div className="my_container point_container mt_48">
            <div className="order_title">
              <div className="d-flex">
                <h3>{t('production_support')}</h3>
                <span className="p2">({makingSupportTotalCount})</span>
              </div>
            </div>

            {/* 데이터 없을때 */}
            {makingSupportData.length === 0 ? (
              <div className="default_info_table no_data text_center pt_48">
                {t('production_support_empty')}
              </div>
            ) : null}
            

            <div className="board_container form_board">
              <BoardForm 
                isMyBoard={false} 
                formType="support" 
                boardList={makingSupportData} 
              />
            </div>

            {makingSupportTotalCount > 0 && (
              <PaginationSection 
                totalCount={makingSupportTotalCount} 
                itemsPerPage={itemsPerPage} 
                currentPage={currentPage} 
                onPageChange={handlePageChange} 
              />
            )}
          </div>
          
        ) : inquiryType === 'inquiry' ? (
          // 1:1 문의
          <div className="my_container point_container mt_48">
            <div className="order_title">
              <div className="d-flex">
                <h3>{t('inquiry')}</h3>
                <span className="p2">({totalCount})</span>
              </div>
              <div className="o_btn">
                <button 
                  type="button" 
                  className="default_btn black xs"
                  onClick={handleInquiry}
                >
                  {t('Contact_us')}
                </button>
              </div>
            </div>

            {/* 데이터 없을때 */}
            {inquiryData.length === 0 ? (
              <div className="default_info_table no_data text_center pt_48">
                {t('inquiry_list2')}
              </div>
            ) : null}
            
            <div className="board_container form_board">
              <BoardForm 
                isMyBoard={false} 
                formType="inquiry" 
                boardList={inquiryData} 
                member_seq={myInfo?.member_seq}
              />
            </div>

            {/* 페이지네이션 추가 */}
            <PaginationSection 
              totalCount={totalCount} 
              itemsPerPage={itemsPerPage} 
              currentPage={currentPage} 
              onPageChange={handlePageChange} 
            />
          </div>

        ) : inquiryType === 'customizing' ? (
          //  커스터마이징 
          <div className="my_container point_container mt_48">
            <div className="order_title">
              <div className="d-flex">
                <h3>{t('customization')}</h3>
                <span className="p2">({customizingTotalCount})</span>
              </div>
              <div className="o_btn">
                <button 
                  type="button" 
                  className="default_btn black xs"
                  onClick={handleCustomizing}
                >
                  {t('write_article')}
                </button>    
              </div>
            </div> 

            {/* 데이터 없을때 */}
            {customizingData.length === 0 ? (
              <div className="default_info_table no_data text_center pt_48">
                {t('customization_empty')}
              </div>
            ) : null}
            
            <div className="board_container form_board">
              <BoardForm 
                isMyBoard={false} 
                formType="customizing" 
                boardList={customizingData} 
                member_seq={myInfo?.member_seq}
              />
            </div>

            {/* 페이지네이션 추가 */}
            <PaginationSection 
              totalCount={customizingTotalCount} 
              itemsPerPage={itemsPerPage} 
              currentPage={currentPage} 
              onPageChange={handlePageChange} 
            />
          </div>

        ) :  inquiryType === 'priceGuarantee' ? (
          //  최저가 보장 
          <div className="my_container point_container mt_48">
            <div className="order_title">
              <div className="d-flex">
                <h3>{t('lowest_price_guarantee')}</h3>
                <span className="p2">({priceGuaranteeTotalCount})</span>
              </div>
              <div className="o_btn">
                <button 
                  type="button" 
                  className="default_btn black xs"
                  onClick={handlePriceGuarantee}
                >
                  {t('report3')}
                </button>    
              </div>
            </div> 

            {/* 데이터 없을때 */}
            {priceGuaranteeData.length === 0 ? (
            <div className="default_info_table no_data text_center pt_48">
              {t('lowest_price_guarantee_inquiry_list')}
            </div>
            ) : null}
            
            <div className="board_container form_board">
              <BoardForm 
                isMyBoard={false} 
                formType="priceGuarantee" 
                boardList={priceGuaranteeData} 
                member_seq={myInfo?.member_seq}
              />
            {/* 페이지네이션 추가 */}
            <PaginationSection 
              totalCount={priceGuaranteeTotalCount} 
              itemsPerPage={itemsPerPage} 
              currentPage={currentPage} 
              onPageChange={handlePageChange} 
            />
            </div>
          </div>

        ) : null}

        

      </div>

    </div>
  )
};

export default InquiryList;